export const PublicRoutes=({element:Component,...props})=>{
    return <Component {...props}/>
  }